import { useEffect, useState } from "react";
import { UseProductVideos } from "./UseProductVideos";
import { useNavigate, useLocation } from "react-router-dom";
import Detail from "../../main/detail/Detail.js";
import { Typography, Button, Box, TextField } from "@mui/material";
import { rsActiveMenu, rsProgress } from "../../RecoilStates.js";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints.js";
import VideosList from "./VideosList.js";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";

export default function ProductVideoDetail() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const navigate = useNavigate();
  const location = useLocation();
  const [state, setState] = useState({
    ProductID: location.state,
    title: null,
    description: null,
  });
  const { getProductByID, createInfo, updateInfo, validate } =
    UseProductVideos();
  const [progress, setProgress] = useRecoilState(rsProgress);

  const { isSmall } = useBreakpoints();
  const [errorState, setErrorState] = useState({
    title: false,
  });

  useEffect(() => {
    loadData();
  }, [location.state]);

  const loadData = () => {
    if (location.state && location.state.id) {
      getProductByID(location.state.id, (value) => {
        setState({
          id: value.id,
          ProductID: value.ProductID,
          title: value.title,
          description: value.description,
          videos: value.videos,
        });
      });
    }
  };

  return (
    <Detail
      breadChilds={{
        title: "محصولات ",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/productvideos" },
          { name: "جزيیات ویدیو محصول ", url: "/productvideos/details" },
        ],
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 1,
          mb: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography variant="body1">
            کد محصول : ({location.state.id}) /
          </Typography>
          <Typography variant="body1">
            نام محصول : {location.state.name}
          </Typography>
        </Box>

        <Button
          variant="text"
          color="secondary"
          onClick={() => {
            navigate("/productvideos", {
              state: { ...location.state, isBack: true },
              replace: true,
            });
          }}
        >
          بازگشت
        </Button>
      </Box>
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
        <Box gridColumn={isSmall ? "span 12" : "span 4"}>
          <TextField
            fullWidth
            value={state?.title ? state.title : ""}
            error={errorState.title}
            label="عنوان"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, title: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 8"></Box>}
        <Box gridColumn="span 12">
          <Typography variant="body1" color="secondary">
            توضیحات :
          </Typography>
          <CKEditor
            config={{
              language: "fa",
              link: {
                decorators: {
                  addTargetToExternalLinks: {
                    mode: "automatic",
                    callback: (url) => /^(https?:)?\/\//.test(url),
                    attributes: {
                      target: "_blank",
                      rel: "noopener noreferrer",
                    },
                  },
                },
              },
            }}
            editor={Editor}
            style={{ p: "100px", width: "100%" }}
            data={state.description ? state.description : ""}
            onChange={(event, editor) => {
              const data = editor.getData();
              if (state.id) {
                setState({ ...state, description: data });
              }
            }}
            onReady={(editor) => {
              editor.editing.view.change((writer) => {
                writer.setStyle(
                  "height",
                  "250px",
                  editor.editing.view.document.getRoot(),
                );
              });
            }}
          />
        </Box>
        <Box
          gridColumn="span 12"
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Button
            variant="contained"
            color="secondary"
            onClick={() => {
              if (state?.id == 0) {
                const requestModel = {
                  ProductID: location.state.id,
                  title: state.title,
                  description: state.description,
                };
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  createInfo(requestModel, () => {
                    loadData();
                  });
                }
              } else {
                const requestModel = {
                  id: state.id,
                  ProductID: location.state.id,
                  title: state.title,
                  description: state.description,
                };
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  updateInfo(requestModel, () => {
                    loadData();
                  });
                }
              }
            }}
          >
            ثبت
          </Button>
        </Box>
      </Box>
      {state?.id !== 0 ? (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 3 }}>
          <Typography sx={{ color: "secondary.main" }} variant="subtitle1">
            ویدیوها
          </Typography>
          <VideosList
            productVideoId={state?.id}
            rows={state?.videos ?? []}
            onCallback={() => loadData()}
          />
        </Box>
      ) : (
        ""
      )}
    </Detail>
  );
}
